import { UserIcon } from 'lucide-react';

import { Skeleton } from '@components/ui/skeleton';

import { CompanyLoading } from './Company';

export function ProviderDetailsLoading() {
  return (
    <div className="grid py-4 lg:p-0">
      <div className="border-secondary mb-6 grid gap-y-8 border-b-2 border-dotted pb-2 lg:grid-cols-2 lg:gap-4 xl:grid-cols-3">
        <div className="relative mb-2">
          <div className="flex justify-between">
            <div className="mb-6 grid h-fit gap-y-1">
              <Skeleton className="h-8 w-8/12" />
              <div className="flex items-center gap-x-2">
                <UserIcon size={20} strokeWidth={1.5} />
                <Skeleton className="h-5 w-6/12" />
              </div>
              <Skeleton className="h-6 w-16 rounded-md" />
            </div>
            <div className="flex h-fit items-center gap-x-2">
              <Skeleton className="size-8 rounded-full" />
              <Skeleton className="size-8 rounded-full" />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <Skeleton className="h-3.5 w-6/12" />
            <Skeleton className="h-3.5 w-6/12" />
            <Skeleton className="mb-2 h-4 w-full" />
            <Skeleton className="mb-2 h-4 w-full" />
            <Skeleton className="h-3.5 w-6/12" />
            <Skeleton className="h-3.5 w-6/12" />
            <Skeleton className="mb-2 h-4 w-full" />
            <Skeleton className="mb-2 h-4 w-full" />
            <Skeleton className="col-span-2 h-3.5 w-6/12" />
            <Skeleton className="col-span-2 mb-2 h-4 w-full" />
          </div>
        </div>

        <CompanyLoading />

        <div className="grid gap-y-4">
          <div className="flex w-fit gap-x-2">
            <Skeleton className="size-15 rounded-lg" />
            <Skeleton className="size-15 rounded-lg" />
          </div>
          <Skeleton className="h-24 w-full" />
          <Skeleton className="h-24 w-full" />
        </div>
      </div>
    </div>
  );
}
